export var ProductMap;
(function (ProductMap) {
    ProductMap["Analytics"] = "pro";
    ProductMap["Eureka"] = "eureka";
    ProductMap["Synapse"] = "synapse";
})(ProductMap || (ProductMap = {}));
export var ProductMapReverse;
(function (ProductMapReverse) {
    ProductMapReverse["pro"] = "Analytics";
    ProductMapReverse["eureka"] = "Eureka";
    ProductMapReverse["synapse"] = "Synapse";
})(ProductMapReverse || (ProductMapReverse = {}));
export var TableRowSize;
(function (TableRowSize) {
    TableRowSize["AUTO"] = "auto";
    TableRowSize["LOW"] = "low";
    TableRowSize["MIDDLE"] = "middle";
    TableRowSize["HIGH"] = "high";
})(TableRowSize || (TableRowSize = {}));
// export enum ViewType {
//     TABLE = 'table',
//     STANDARD = 'standard',
//     FULL_IMAGE = 'full_image',
//     THUMB = 'thumbnail',
//     FAST_TABLE = 'fast_table',
//     WORD_CLOUD = 'word_cloud',
// }
